import React from 'react';
import { X, Clock, Award } from 'lucide-react';
import type { Perfil, Subtopico } from '../../../types';

interface VideoPlayerModalProps {
  showDetailsModal: boolean;
  setShowDetailsModal: (show: boolean) => void;
  selectedSubtopico: Subtopico | null;
  effectivePerfil: Perfil;
  activeStyles: { color: string; bgLight: string; borderLight: string };
}

export function VideoPlayerModal({
  showDetailsModal,
  setShowDetailsModal,
  selectedSubtopico,
  effectivePerfil,
  activeStyles,
}: VideoPlayerModalProps) {
  if (!showDetailsModal || !selectedSubtopico) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(2, 6, 23, 0.75)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#0f172a',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '16px',
        width: '90%',
        maxWidth: '540px',
        padding: '24px',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.6)',
        color: '#f8fafc',
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        fontFamily: "'Plus Jakarta Sans', sans-serif"
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
          paddingBottom: '12px'
        }}>
          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: 800,
            fontFamily: "'Outfit', sans-serif",
            margin: 0,
            color: '#ffffff'
          }}>
            Sobre o Treinamento
          </h3>
          <button
            onClick={() => setShowDetailsModal(false)}
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px',
              borderRadius: '6px',
              transition: 'all 0.2s'
            }}
            title="Fechar"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <h4 style={{
            fontSize: '1.1rem',
            fontWeight: 700,
            color: '#ffffff',
            margin: 0
          }}>
            {selectedSubtopico.titulo}
          </h4>

          {/* Badges Row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <span style={{
              fontSize: '0.7rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              padding: '4px 10px',
              borderRadius: '6px',
              background: activeStyles.bgLight,
              color: activeStyles.color,
              border: `1px solid ${activeStyles.borderLight}`
            }}>
              {effectivePerfil.nome}
            </span>
            <span style={{
              fontSize: '0.7rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              padding: '4px 10px',
              borderRadius: '6px',
              background: 'rgba(255, 255, 255, 0.05)',
              color: '#cbd5e1'
            }}>
              {selectedSubtopico.dificuldade}
            </span>
            <span style={{ 
              fontSize: '0.8rem', 
              color: '#94a3b8', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '4px'
            }}>
              <Clock size={13} style={{ color: activeStyles.color }} />
              {selectedSubtopico.duracao}
            </span>
          </div>

          {/* Description */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.02)',
            border: '1px solid rgba(255, 255, 255, 0.04)',
            borderRadius: '10px',
            padding: '14px',
            fontSize: '0.88rem',
            color: '#cbd5e1',
            lineHeight: 1.5,
            maxHeight: '220px',
            overflowY: 'auto'
          }}>
            {selectedSubtopico.descricao}
          </div>
        </div>

        {/* Footer */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          borderTop: '1px solid rgba(255, 255, 255, 0.06)',
          paddingTop: '12px'
        }}>
          <button
            onClick={() => setShowDetailsModal(false)}
            style={{
              background: activeStyles.bgLight,
              border: `1px solid ${activeStyles.borderLight}`,
              borderRadius: '8px',
              padding: '8px 20px',
              color: '#ffffff',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}
